import { useNavigate } from "@tanstack/solid-router";
import { TICKET_PURCHASE_URL } from "~/lib/tickets";

type Props = {
  eventId: string;
};

export function DraftProfileBanner(props: Props) {
  const navigate = useNavigate();

  return (
    <div class="draft-banner" role="status">
      <p>
        <strong>Draft profile</strong> — ticket not linked. You won't appear in the directory or
        connect with anyone until your ticket is verified.
      </p>
      <div class="draft-banner-actions">
        <button
          type="button"
          class="btn btn-outline btn-sm"
          onClick={() =>
            navigate({ to: "/onboarding/$eventId", params: { eventId: props.eventId } })
          }
        >
          Link ticket
        </button>
        <a
          class="btn btn-ghost btn-sm"
          href={TICKET_PURCHASE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get tickets
        </a>
      </div>
    </div>
  );
}